module.exports = __webpack_public_path__ + "static/media/welcome_2.43728366.webp";